import React from 'react'
import { Card } from 'react-bootstrap'
import styled from '@emotion/styled'

import SearchInput, { SearchInputProps } from '../common/SearchInput'
import Table, { TableProps } from '../common/Table'
import TableDnd from '../common/TableDnd'
import { DragEndEvent } from '@dnd-kit/core'

type ListPageProps = {
  searchInputProps?: SearchInputProps
  tableProps: TableProps
  onDragEnd?: (event: DragEndEvent) => void | undefined
  topbar?: JSX.Element
  showPaginate?: boolean
  bottombar?: JSX.Element
}

const TopbarLayout = styled.div`
  display: flex;
  align-items: baseline;
  grid-column-gap: 12px;
`

export default (props: ListPageProps) => {
  const { searchInputProps, tableProps, topbar, onDragEnd, showPaginate = true, bottombar } = props
  return (
    <>
      <Card>
        <Card.Body>
          <TopbarLayout>
            {searchInputProps && <SearchInput {...searchInputProps} />}
            {topbar}
          </TopbarLayout>
          {onDragEnd ? (
            <TableDnd
              showPaginate={showPaginate}
              onDragEnd={onDragEnd}
              style={{ marginTop: 10 }}
              {...tableProps}
            />
          ) : (
            <Table style={{ marginTop: 10 }} showPaginate={showPaginate} {...tableProps} />
          )}
          {bottombar}
        </Card.Body>
      </Card>
    </>
  )
}
